import React, { useEffect, useState } from "react"
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Box,
} from "@mui/material"
import { styled } from "@mui/system"
import {
    CwComponentConfig,
    PageConfig,
} from "@front-apps/core/models/pageConfig"
import spainFlag from "../assets/img/spain-flag.png"
import ukFlag from "../assets/img/gb-flag.png"
import frenchFlag from "../assets/img/french-flag.png"
import italianFlag from "../assets/img/italian-flag.png"
import deutschFlag from "../assets/img/deutsch-flag.png"
import i18n from "../assets/translations/i18n"
import StoreService from "@front-apps/core/services/store"
import DialogService from "@front-apps/core/services/dialog"
import { DialogType } from "@front-apps/core/models/dialog"

const CustomFormControlLabel = styled(FormControlLabel)(({ checked }) => ({
    margin: "10px 0",
    border: checked ? `2px solid #200943` : "2px solid #bde0fe",
    borderRadius: "8px",
    padding: "10px 10px 10px 10px",
    backgroundColor: "white",
    transition: "background-color 0.3s, border-color 0.3s",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "250px",
}))

const CustomRadio = styled(Radio)(({ checked }) => ({
    color: checked ? "#200943" : "#bde0fe",
    "&.Mui-checked": {
        color: "#200943",
    },
}))

const CwRadioButtonList = (
    props: PageConfig<CwComponentConfig.RadioButtonList>
) => {
    const [selectedLanguage, setSelectedLanguage] = useState("")

    const onChange = async (lang: string) => {
        i18n.changeLanguage(lang)
        await StoreService.getInstance().persistant.set("lang", lang)
    }
    const handleChange = (event: any) => {
        DialogService.getInstance().send({
            type: DialogType.REFRESH,
            sender: "languageRadio",
            params: [],
            to: "description",
        })
        const lang = event.target.value
        setSelectedLanguage(lang)
        onChange(lang)
        DialogService.getInstance().send({
            sender: "pageRefesh",
            type: DialogType.REFRESH,
            to: "confirmButton",
        })
    }

    const getCurrentLang = async () => {
        const lang = await StoreService.getInstance().persistant.get("lang")
        return lang
    }

    useEffect(() => {
        const fetchLang = async () => {
            const lang = await getCurrentLang()
            if (lang && typeof lang === "string") {
                setSelectedLanguage(lang)
            }
        }
        fetchLang()
    }, [])

    const languages = [
        { value: "en", label: "English", flag: ukFlag },
        { value: "es", label: "Español", flag: spainFlag },
        { value: "fr", label: "Français", flag: frenchFlag },
        { value: "it", label: "Italiano", flag: italianFlag },
        { value: "de", label: "Deutsch", flag: deutschFlag },
    ]

    return (
        <div>
            <FormControl component="fieldset">
                <RadioGroup value={selectedLanguage} onChange={handleChange}>
                    {languages.map((lang) => (
                        <CustomFormControlLabel
                            key={lang.value}
                            checked={selectedLanguage === lang.value}
                            value={lang.value}
                            control={
                                <CustomRadio
                                    checked={selectedLanguage === lang.value}
                                />
                            }
                            labelPlacement="start"
                            label={
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    width="100%"
                                >
                                    <Box display="flex" alignItems="center">
                                        <img
                                            src={lang.flag}
                                            alt={`${lang.label} Flag`}
                                            style={{
                                                marginRight: "10px",
                                                width: "42px",
                                                height: "auto",
                                                borderRadius: "5px",
                                            }}
                                        />
                                        {lang.label}
                                    </Box>
                                </Box>
                            }
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </div>
    )
}

export default CwRadioButtonList
